import { useCifraClient } from '@/api/cifra-client';

/**
 * Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
 * Es la llamada a asiganaturas/json que es un método muy viejo que se usa para
 * obtener las asignaturas
 */

const { cifraClient } = useCifraClient();

export default {
  list(parametros) {
    return cifraClient.get('/asignaturas/json', {
      params: parametros,
    });
  },
  /**
   * Devuelve la información con el formato para usar con select2
   * @param {*} parametros
   * @returns
   */
  select2(parametros) {
    const params = { format: 'select2', ...parametros };
    return cifraClient.get('/asignaturas/json', {
      params,
    });
  },
};
